<ng-container *ngFor="let engagement of engagements; let i = index; trackBy: trackByFn">
  <treo-card class="note mt-4">
    <section class="note-content">
      <!-- Note Header -->
      <article class="note-content__header">
        <!-- Note Title -->
        <div>
          <strong>Logged {{ engagement.engagement_type }}</strong> by {{ engagement.user_name }}
        </div>

        <!-- Date -->
        <div class="date">
          {{ engagement.event_date | date: 'LLL dd, y, h:mm a' }}
        </div>

        <!-- Three-dot menu -->
        @if ([NewPermission.ENGAGEMENTS_EDIT, NewPermission.ENGAGEMENTS_DELETE] | hasPermission: 'any') {
          <div>
            <button class="more-menu" mat-icon-button [matMenuTriggerFor]="moreMenu" [matTooltip]="'More options'">
              <mat-icon [svgIcon]="'more_vert'"></mat-icon>
            </button>
            <mat-menu #moreMenu="matMenu">
              <button
                [appAuthorize]="NewPermission.ENGAGEMENTS_EDIT"
                mat-menu-item
                (click)="editEngagement(engagement)"
              >
                <mat-icon class="edit-icon" [svgIcon]="'edit'"></mat-icon>
                <span>Edit</span>
              </button>
              <button
                [appAuthorize]="NewPermission.ENGAGEMENTS_DELETE"
                mat-menu-item
                (click)="deleteEngagement(engagement)"
              >
                <mat-icon [svgIcon]="'delete'"></mat-icon>
                <span>Delete</span>
              </button>
            </mat-menu>
          </div>
        }
      </article>

      <!-- Note body editor -->
      <article class="note-content__note-body">
        <quill-view-html [content]="engagement.body" theme="snow" sanitize></quill-view-html>
      </article>

      <mat-divider class="w-full pt-2 pb-2"></mat-divider>
      <article class="note-content__note-footer p-2 flex flex-row justify-between w-full">
        <div *ngIf="engagement.contact">
          Contact: <strong>{{ engagement.contact?.name }}</strong>
        </div>
        <div *ngIf="engagement.call_outcome">
          Outcome: <strong>{{ engagement.call_outcome?.name }}</strong>
        </div>
        <div *ngIf="engagement.meeting_outcome">
          Outcome: <strong>{{ engagement.meeting_outcome?.name }}</strong>
        </div>
        <div *ngIf="engagement.call_direction">
          Direction: <strong>{{ engagement.call_direction }}</strong>
        </div>
        <div *ngIf="engagement.engagement_activity_type">
          Type: <strong>{{ engagement.engagement_activity_type?.name }}</strong>
        </div>
        <div *ngIf="engagement.social_media_profile">
          Profile: <strong>{{ engagement.social_media_profile }}</strong>
        </div>
        <div *ngIf="engagement.social_media_source">
          Source: <strong>{{ engagement.social_media_source?.name }}</strong>
        </div>
      </article>
    </section>
  </treo-card>
</ng-container>
